enum Sections {
  CATCHUP = 'catchup',
  CHANNELS_MAIN = 'channels',
  CHANNELS_U7D = 'channelU7d',
  DEAD_MAN = 'deadMan',
  DIAL = 'dial',
  GUIDE_PLATFORMS = 'guidePlatforms',
  GUIDE_TV = 'guideTv',
  LIVE = 'live',
  MORE_CONTENT = 'moreContent',
  MOVIES = 'cineU7d',
  MY_RECORDINGS = 'myRecordings',
  RECORDING = 'recording',
  RESTART_LIVE = 'restartLive',
  SERIES = 'seriesU7d',
  SHOWS = 'programsU7d',
  START_APP = 'startApp',
  START_THIRD_PARTY_APP = 'startThirdPartyApp',
}

enum QuerySections {
  INITIAL = 'INICIO',
  MOVIES = 'CINE',
  SERIES = 'SERIE',
  SHOWS = 'SHOWS',
}

export { QuerySections };
export default Sections;
